import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import projects from './projects'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  namespaced: true,
  modules: {
    projects,
  }
})

export default store
